export enum PersonalizationTagEnum {
    // NEP-18499 NAME = 'NAME',
    PREFIX = 'PREFIX',
    FNAME = 'FNAME',
    LNAME = 'LNAME',
    OUTLET_NAME = 'OUTLET_NAME',
    // CITY = 'CITY,
    X_HANDLE = 'X_HANDLE',
    INTRO = 'INTRO',
    OUTRO = 'OUTRO'
}
